import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-ebu-over-usage-alert',
	templateUrl: './ebu-over-usage-alert.component.html',
	styleUrls: ['./ebu-over-usage-alert.component.css']
})
export class EbuOverUsageAlertComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];
	title: string = 'EBU Over Usage Alert';
	elementId: string = 'batt_alert_over_usage';
	widgetClass: string = 'height-530';
	siteWidgetOptions: any = {
		hasDate: true,
		isAlertWidget: true,
		hasOperation: true
	};

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#109618' },
				{ color: '#bd2f26' },
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			formattedData.push([{v: "No EBU Over Usage Alert"}, {v: data.Pie[0].ok_count}]);
			formattedData.push([{v: "EBU Over Usage Alerts"}, {v: data.Pie[1].bad_count}]);
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push({title: "Average EBUs", property: "average"});
			tableColumns.push({title: "Max EBUs", property: "max"});
			tableColumns.push({title: "Days of EBU over usage", property: "ebus"});
			this.tableColumns = tableColumns;
		}
	}
}
